import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import {
    Assignment,
    AnalyticsOutlined,
    BarChart,
    Dashboard as DashboardIcon,
    DirectionsCar,
    TableChart
} from "@mui/icons-material";
import { strings } from "../../i18n";
import config from "../../../config";
import { useNavigate } from "react-router-dom";
import { useHasAdminGroup } from "../../hooks";
import { useAuthenticated } from "../../hooks";


const routePrefix = config.paths.auth;

const paths = {
    assets: `/${routePrefix}/${config.paths.assets}`,
    allasset: `/${routePrefix}/${config.paths.allasset}`,
    audits: `/${routePrefix}/${config.paths.audits}/inprogress`,
    dashboard: `/${routePrefix}/${config.paths.dashboard}`,
    dataCheck: `/${routePrefix}/${config.paths.dataCheck}`,
    funderCheck: `/${routePrefix}/${config.paths.funderCheck}`,
    reports: `/${routePrefix}/${config.paths.reports}`,
    operations: `/${routePrefix}/${config.paths.operations}`,
    manage: `/${routePrefix}/${config.paths.manage}`,
    setup: `/${routePrefix}/${config.paths.setup}/branches`
};

/**
 * Screen Use Drawer-items Hook
 */
export default () => {
    const { userOrganisations } = useSelector((state) => state);
    let navigate = useNavigate();
    const isAdmin = useHasAdminGroup();
    const { auditGroup } = useAuthenticated();


    const next = useMemo(() => {
        return [
            {
                isAdmin: true,
                Icon: DashboardIcon,
                key: "dashboard",
                onClick: () => navigate(paths.dashboard),
                path: paths.dashboard,
                primary: strings("dashboard")
            },
            {
                isAdmin: true,
                Icon: Assignment,
                key: "audits",
                onClick: () => navigate(paths.audits),
                path: paths.audits,
                primary: strings("audits")
            },
            {
                isAdmin: true,
                Icon: DirectionsCar,
                key: "assets",
                onClick: () => navigate(paths.allasset),
                path: paths.allasset,
                primary: strings("assets")
            },
            {
                isAdmin: true,
                Icon: DirectionsCar,
                key: "datacheck",
                onClick: () => navigate(paths.dataCheck),
                path: paths.dataCheck,
                primary: strings("dataCheck")
            },
            {
                isAdmin: true,
                disabled: !userOrganisations.item.isFunderCheck,
                Icon: AnalyticsOutlined,
                key: "funderCheck",
                onClick: () => navigate(paths.funderCheck),
                path: paths.funderCheck,
                primary: strings("funderCheck")
            },
            {
                isAdmin: true,
                Icon: BarChart,
                key: "reports",
                onClick: () => navigate(paths.reports),
                path: paths.reports,
                primary: strings("reports")
            },
            {
                isAdmin: isAdmin,
                disabled: false,
                Icon: TableChart,
                key: "operations",
                onClick: () => navigate(paths.operations),
                path: paths.operations,
                primary: strings("operations")
            },
            {
                isAdmin: isAdmin,
                disabled: false,
                Icon: TableChart,
                key: "manage",
                onClick: () => navigate(paths.manage),
                path: paths.manage,
                primary: strings("manageOrg")
            }
        ];
    }, [userOrganisations, isAdmin]);

    return next.filter((item) => item.isAdmin);;
};
